<template>
  <div class="fullBox" :style="{ backgroundImage: `url(${defaultBg})` }">
    <div class="header">
      <img class="ks_logo" src="@/assets/img/ks_logo.png" />
      <div class="divider"></div>
      <img class="ky_logo" src="@/assets/img/ky_logo.png" />
      <h1 class="tag">快手官方视频剪辑神器</h1>
    </div>
    <div class="content">
      <h2 class="title">快影，创作有趣的视频</h2>
      <p class="desc">剪辑、音频、字幕、特效，专业简单好用</p>
      <div class="download-box">
        <div
          class="download-btn"
          @click="openKy()"
          @mouseenter="() => onMouseEvent('ios', true)"
          @mouseleave="() => onMouseEvent('ios', false)"
        >
          <img class="download_apple" src="@/assets/img/apple.png" />
          <b>App Store</b>
          <div class="qr_apple" v-if="isIOSHover">
            <LazyImg :src="qrCode.ios" />
          </div>
        </div>
        <div
          class="download-btn"
          @click="openKy()"
          @mouseenter="() => onMouseEvent('android', true)"
          @mouseleave="() => onMouseEvent('android', false)"
        >
          <img class="download_android" src="@/assets/img/android.png" /><b
            >Android</b
          >
          <div class="qr_apple" v-if="isAndroidHover">
            <LazyImg :src="qrCode.android" />
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-content">
      <img
        class="ky_logo_without_text"
        src="@/assets/img/ky_logo_without_text.png"
      />
      <h3 class="mobile-title">快影</h3>
      <p class="desc" style="margin-top: 0.24rem">
        剪辑、音频、字幕、特效，专业简单好用
      </p>
      <div class="download-btn" @click="openKy()" style="margin-top: 0.4rem">
        <b>立即下载App</b>
      </div>
      <span
        v-if="!device.isIOS && device.system !== 'other'"
        @click="openKy(true)"
        class="download32"
        >下载32位兼容版</span
      >
    </div>
    <div
      :style="{
        position: 'absolute',
        width: '100%',
        height: '100vh',
        opacity: 0,
        zIndex: -1,
      }"
    >
      <img
        src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/kuaiyin_icon.f14f68a442919cf8.png"
        alt="快影-简单好用的剪辑软件"
      />
    </div>
    <FullVideo
      v-if="isLargeWindow"
      :video-url="'https://p4-ky.wsukwai.com/udata/pkg/kmovie/ky_official_website/origin_961aa91fdc998b36c94aa677dadca565.d23f780961d366a5.mp4'"
      :box-style="{
        position: 'absolute',
        width: '100%',
        height: '100vh',
        zIndex: -1,
        backgroundColor: '#141414',
        minHeight: '760px',
      }"
    />
    <div
      v-else
      :style="{
        position: 'absolute',
        width: '100%',
        height: '100vh',
        zIndex: -1,
        backgroundColor: '#141414',
        minHeight: '760px',
      }"
    >
      <img
        src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/1.491bc6a331546957.webp"
        style="width: 100%; height: 100%"
        :onerror="onError"
      />
    </div>
    <div
      style="
        position: absolute;
        width: 100%;
        height: 32px;
        bottom: 50px;
        display: flex;
        justify-content: center;
      "
    >
      <img
        src="@/assets/img/arrow-down.png"
        style="width: 32px; height: 32px"
        class="animate__fadeInUp animate__animated animate__infinite"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType, getCurrentInstance } from "vue";
import open from "@ky/sdk/dist/open";
import kylogger from "@ky/sdk/dist/log/kylogger";
import device from "@/utils/device";

import FullVideo from "./FullVideo.vue";
import LazyImg from "../VueLazyImg.vue";

type qrCodeType = {
  ios: string;
  android: string;
};
const { qrCode, isLargeWindow } = defineProps({
  qrCode: {
    type: Object as PropType<qrCodeType>,
    default: () => {
      return {
        ios: "",
        android: "",
      };
    },
  },
  isLargeWindow: {
    type: Boolean,
    default: false,
  },
});
const defaultBg = ref("");
const isIOSHover = ref(false);
const isAndroidHover = ref(false);
function isMobile() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
  );
}
// 支持指定快影落地页
let jumpUrl = '';
try {
  const route = useRoute();
  const queryUrl = decodeURIComponent((route.query.url || '') as string);
  jumpUrl = queryUrl.startsWith('kwaiying://') ? queryUrl : "kwaiying://";
} catch {
  jumpUrl = "kwaiying://";
}
function openKy(use32 = false) {
  if (isMobile()) {
    const logBtn = device.system === "ios" ? "App Store" : device.system;
    console.log("logBtn", logBtn);
    kylogger.collect("CLICK", "DOWNLOAD", {
      button: logBtn,
    });
    open(jumpUrl, {
      use32,
    });
  }
}
function onMouseEvent(type: "ios" | "android", isEnter: boolean) {
  let logBtn = "";
  if (type === "ios") {
    isIOSHover.value = isEnter;
    logBtn = "App Store";
  }
  if (type === "android") {
    isAndroidHover.value = isEnter;
    logBtn = "Android";
  }
  if (isEnter) {
    kylogger.collect("SHOW", "DOWNLOAD", {
      button: logBtn,
    });
  }
}

function onError() {
  defaultBg.value =
    "https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/bg_static.880dd0980b5659a7.png";
}
</script>
<style lang="less" scoped>
.fullBox {
  height: 100%;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 768px) {
  .header {
    height: 0;
    overflow: hidden;
  }
  .content {
    height: 0;
    overflow: hidden;
  }
  .mobile-content {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;
    flex: 1;
  }
  .download32 {
    font-size: 0.2rem;
    text-decoration: underline;
    color: #eee;
    margin-top: 0.2rem;
  }
}
@media screen and (min-width: 768px) {
  .content {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;
    flex: 1;
  }
  .mobile-content {
    height: 0;
    overflow: hidden;
  }
  .header {
    height: 8vh;
    background: rgba(20, 20, 20, 0.5);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
  }
}
.divider {
  margin: 0 0.28rem;
  width: 1px;
  height: 0.2rem;
  border-radius: 0.12rem;
  background: rgba(255, 255, 255, 0.4);
}
.ks_logo {
  height: 0.28rem;
  width: 0.77rem;
}
.ky_logo {
  height: 0.22rem;
  width: 0.8rem;
}
.ky_logo_without_text {
  width: 0.96rem;
  height: 0.96rem;
}
.tag {
  padding: 4px 12px;
  border-radius: 4px;
  border: 0.5px solid #fff;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-family: PingFang SC;
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 0.24rem;
}

.title {
  color: #fff;
  font-family: Source Han Sans SC;
  font-size: 0.64rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.001px;
}
.desc {
  color: #fff;
  font-family: PingFang SC;
  font-size: 0.24rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 0.38rem;
}
.download-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 0.65rem;
}
.download-btn {
  border-radius: 0.6rem;
  border: 0.89px solid #fff;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 1.92rem;
  height: 0.56rem;
  margin: 0 14px;
  position: relative;
  cursor: pointer;
  .qr_apple {
    position: absolute;
    width: 1.92rem;
    height: 1.92rem;
    top: 0.8rem;
  }
  .download_apple {
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.14rem;
  }
  .download_android {
    width: 0.33rem;
    height: 0.33rem;
    margin-right: 0.1rem;
  }
  b {
    color: #fff;
    font-family: PingFang SC;
    font-size: 0.21rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}
.mobile-title {
  color: #fff;
  font-family: Source Han Sans SC;
  font-size: 0.42rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 0.32rem;
}
</style>
